import * as React from 'react';
import createSvgIcon from './utils/createSvgIcon';
export default createSvgIcon( /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("path", {
  d: "M16 14.14V9.86L12.97 12z",
  opacity: ".3"
}), /*#__PURE__*/React.createElement("path", {
  d: "M6 6h2v12H6zm12 12V6l-8.5 6 8.5 6zm-2-3.86L12.97 12 16 9.86v4.28z"
})), 'SkipPreviousTwoTone');


//////////////////
// WEBPACK FOOTER
// ./~/@material-ui/icons/esm/SkipPreviousTwoTone.js
// module id = 6272
// module chunks = 2